import { ReceiptsRequestInterface } from '../../../interfaces/request/receipts/receipts-request-interface';

export class ReceiptsRequestModel implements ReceiptsRequestInterface {
  ClientId: string = '';
  ReceiptNumber: string = '';
  ReceiptSituation: string = '';
  ReceiptStartDateEnd: string = '';
  ReceiptStartDateStart: string = '';
  page: number | undefined;
  pageSize: number | undefined;
  policyNumber?: string = '';
  policyId?: number | undefined;

  constructor(init?: Partial<ReceiptsRequestModel>) {
    Object.assign(this, init);
  }
}
